import MenuNames from "../../../constants/Menu/MenuNames.json";
import Index from "../../../views/Orders/Index";
import Show from "../../../views/Orders/Show";

const OrdersRoutes = [
  {
    menuName: MenuNames.ORDERS,
    path: "/orders",
    component: Index,
    exact: true,
  },
  {
    menuName: MenuNames.ORDERS,
    path: "/orders/:id/:detailType?",
    component: Show,
    exact: false,
  },
];

export default OrdersRoutes;
